import {
  SET_MARCA_BLANCA_VALIDATED,
  SET_MARCA_BLANCA_CLIENT,
  BLOCK_MARCA_BLANCA,
  SHOW_MARCA_BLANCA_CART_LIMIT,
  HIDE_MARCA_BLANCA_CART_LIMIT,
  SET_MARCA_BLANCA_HASH_VALIDATING,
  SET_MARCA_BLANCA_HASH_FAILED,
  RESET_MARCA_BLANCA_HASH,
  SET_MARCA_BLANCA_SELLER_CODE,
  CLEAR_MARCA_BLANCA_SELLER_CODE,
  SET_MARCA_BLANCA_BRANCH,
  MarcaBlancaClient,
  MarcaBlancaHashStatus,
} from "../actions/marcaBlancaActions";
import { MarcaBlancaAuthResponse, Branch } from "../../hooks/useMarcaBlancaAuth";

export interface MarcaBlancaState {
  validated: boolean;
  clientId: string;
  documentNumber: string;
  documentTypeId: string | number;
  documentTypeCode: string;
  lastBlockedAt: number | null;
  // Datos del comercio que prellenan el checkout de Marca Blanca.
  client: MarcaBlancaClient | null;
  showCartLimit: boolean;
  hashAuthStatus: MarcaBlancaHashStatus;
  hashAuthResponse: MarcaBlancaAuthResponse | null;
  // Código de vendedor validado con éxito en el paso 2, conservado para el paso 3.
  sellerCode: string;
  sellerCodeValidated: boolean;
  branch: Branch | null;
}

const initialState: MarcaBlancaState = {
  validated: false,
  clientId: "",
  documentNumber: "",
  documentTypeId: "",
  documentTypeCode: "",
  client: null,
  lastBlockedAt: null,
  showCartLimit: false,
  hashAuthStatus: "idle",
  hashAuthResponse: null,
  sellerCode: "",
  sellerCodeValidated: false,
  branch: null,
};

const marcaBlancaReducer = (
  state: MarcaBlancaState = initialState,
  action: any
): MarcaBlancaState => {
  switch (action.type) {
    case SET_MARCA_BLANCA_VALIDATED: {
      return {
        ...state,
        validated: true,
        clientId: action.payload.clientId,
        documentNumber: action.payload.documentNumber,
        documentTypeId: action.payload.documentTypeId,
        documentTypeCode: action.payload.documentTypeCode ?? "",
      };
    }
    case SET_MARCA_BLANCA_CLIENT: {
      return {
        ...state,
        client: action.payload,
      };
    }
    case BLOCK_MARCA_BLANCA: {
      return {
        ...state,
        validated: false,
        clientId: "",
        documentNumber: "",
        documentTypeId: "",
        documentTypeCode: "",
        client: null,
        lastBlockedAt: Date.now(),
        hashAuthStatus: "failed",
        sellerCode: "",
        sellerCodeValidated: false,
        branch: null,
      };
    }
    case SHOW_MARCA_BLANCA_CART_LIMIT: {
      return {
        ...state,
        showCartLimit: true,
      };
    }
    case HIDE_MARCA_BLANCA_CART_LIMIT: {
      return {
        ...state,
        showCartLimit: false,
      };
    }
    case SET_MARCA_BLANCA_HASH_VALIDATING: {
      return {
        ...state,
        hashAuthStatus: "validating",
        hashAuthResponse: null,
      };
    }
    case SET_MARCA_BLANCA_HASH_FAILED: {
      return {
        ...state,
        hashAuthStatus: "failed",
        hashAuthResponse: action.payload ?? null,
      };
    }
    case RESET_MARCA_BLANCA_HASH: {
      return {
        ...state,
        hashAuthStatus: "idle",
        hashAuthResponse: null,
      };
    }
    case SET_MARCA_BLANCA_SELLER_CODE: {
      return {
        ...state,
        sellerCode: action.payload,
        sellerCodeValidated: true,
      };
    }
    case CLEAR_MARCA_BLANCA_SELLER_CODE: {
      return {
        ...state,
        sellerCode: "",
        sellerCodeValidated: false,
      };
    }
    case SET_MARCA_BLANCA_BRANCH: {
      return {
        ...state,
        branch: action.payload ?? null,
      };
    }
    default: {
      return state;
    }
  }
};

export default marcaBlancaReducer;
